(function () {
  function initChecklist(root) {
    var inputs = Array.prototype.slice.call(
      root.querySelectorAll('[data-checklist-input]')
    );
    var counter = root
      .closest('.pain-checklist')
      .querySelector('[data-checklist-counter]');
    var closing = root
      .closest('.pain-checklist')
      .querySelector('[data-checklist-closing]');

    if (inputs.length === 0) return;

    var total = inputs.length;

    function update() {
      var checkedCount = inputs.filter(function (input) {
        return input.checked;
      }).length;

      if (counter) {
        counter.textContent = checkedCount + ' / ' + total + ' cochées';
        counter.classList.toggle('is-complete', checkedCount === total);
      }

      if (closing) {
        closing.classList.toggle('is-emphasized', checkedCount === total);
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  }

  function initAll() {
    var checklists = document.querySelectorAll('[data-checklist]');
    checklists.forEach(initChecklist);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();